import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

const WarningIcon = ({ className}: PropsType ): React.ReactElement => (
    <SvgElement fill='#fff' className={ className } xmlns='http://www.w3.org/2000/svg' width={27} height={23} viewBox='0 0 27 23'>
        <g fill='#fill'>
            <path d='M25.048 22.965H1.095c-.017-.005-.033-.011-.05-.013a1.173 1.173 0 01-1.01-.89A2.568 2.568 0 010 21.9v-.228c.035-.184.091-.36.187-.525L10.98 2.456c.354-.614.71-1.227 1.063-1.842.152-.263.368-.45.656-.546.103-.033.212-.046.318-.068h.107c.012.003.024.009.036.01.436.041.747.263.964.64 2.972 5.15 5.946 10.3 8.92 15.45.981 1.698 1.966 3.395 2.945 5.095.062.108.096.233.136.352.02.06.022.124.032.186v.091c-.004.025-.01.05-.012.074-.047.474-.369.87-.824 1.008-.09.027-.183.04-.274.06zm-21.834-2.36h19.719L13.073 3.53 3.215 20.605z' />
            <path d='M14.249 11.403c0 .88.003 1.759-.001 2.638a1.17 1.17 0 01-.89 1.122 1.174 1.174 0 01-1.46-1.157c-.001-1.735 0-3.471.002-5.207a1.173 1.173 0 012.337-.17c.009.07.012.142.012.212v2.562zm-1.176 4.835c.813 0 1.47.656 1.469 1.468 0 .808-.665 1.471-1.472 1.47a1.479 1.479 0 01-1.466-1.477 1.469 1.469 0 011.469-1.461z' />
        </g>
    </SvgElement>
);

export default WarningIcon;
